import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent } from './layout.component';
import { AddEditComponent } from './add-edit.component';
import { ListComponent } from './list.component';

// Lazy load standalone dealer components
const routes: Routes = [
    {
        path: '', component: LayoutComponent,
        children: [
            { 
                path: '', 
                loadComponent: () => import('./dealer-list.component').then(m => m.DealerListComponent)
            },
            { path: 'editDealer/:dealerId/add', component: AddEditComponent },
            { 
                path: 'addDealer', 
                loadComponent: () => import('./add-dealer.component').then(m => m.AddDealerComponent)
            },
            { path: 'editDealer/:dealerId/edit/:id', component: AddEditComponent },
            { 
                path: 'editDealer/:id', 
                loadComponent: () => import('./add-dealer.component').then(m => m.AddDealerComponent)
            },
            { path: 'add/:dealerId', component: AddEditComponent },
            { 
                path: 'viewDealer', 
                loadComponent: () => import('./view-dealer/view-dealer.component').then(m => m.ViewDealerComponent)
            },
            { path: 'viewDealer/add', component: AddEditComponent },
            { path: 'viewDealer/edit/:id', component: AddEditComponent },
            { 
                path: 'dealerPayout/:id', 
                loadComponent: () => import('./dealer-payout/dealer-payout.component').then(m => m.DealerPayoutComponent)
            },
            { 
                path: 'dealerPayout', 
                loadComponent: () => import('./dealer-payout/dealer-payout.component').then(m => m.DealerPayoutComponent)
            },
            { 
                path: 'printInvoice', 
                loadComponent: () => import('./dealer-payout/print-invoice/print-invoice.component').then(m => m.PrintInvoiceComponent)
            },
            { path: 'userList', component: ListComponent },
            { path: 'userList/add', component: AddEditComponent },
            { path: 'userList/edit/:id', component: AddEditComponent },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UsersRoutingModule { }